import * as Sentry from "@sentry/browser"

const IGNORE_ERROR_CODES = [400, 401, 403, 404, 418, 422, 429]
const IGNORED_EXCEPTION_MESSAGE = ["Request aborted"]

export const initSentry = ({ dsn, user }: { dsn: string; user?: Sentry.User }) => {
    Sentry.init({
        dsn,
        environment: window.ENVIRONMENT,
        release: window.CURRENT_VERSION,
        debug: window.ENVIRONMENT === "Development",
        enabled: window.ENVIRONMENT !== "Development",
        beforeSend(event) {
            // Filter out errors with ignored HTTP status codes
            // Check multiple possible locations where status code might be stored
            const exceptionValue = event.exception?.values?.[0]?.value as any

            const statusCode =
                exceptionValue?.response?.status ||
                (exceptionValue && parseInt(String(exceptionValue).match(/status code (\d+)/)?.[1], 10))

            // Filter out abort errors - these occur when users navigate away from a page before
            // API requests complete (e.g., user clicks a link while campaign/event data is still loading).
            // These are expected, normal behavior and not actual errors that need to be fixed.
            if (IGNORED_EXCEPTION_MESSAGE.includes(exceptionValue)) return null

            return statusCode && IGNORE_ERROR_CODES.includes(statusCode) ? null : event
        },
    })

    if (user) {
        Sentry.setUser(user)
    }

    // Remap the legacy SDK to the new one
    // @ts-expect-error We replaced Raven with Sentry, no point in typing dead code
    window.Raven = Sentry
}
